import { css } from "@emotion/react"
import styled from "@emotion/styled"

const dinamicStyles = ({ theme, lowerText }) => css`
  ${lowerText &&
  `
    ${theme.breakpoints.down("xl")} {
      margin-bottom: 79px; 
    }

    ${theme.breakpoints.between("xl", "2xl")} {
      margin-bottom: 94px;  
    }

    ${theme.breakpoints.up("2xl")} {
      margin-bottom: 137px;  
    }
  `}
`

const ListTwoStack = styled.div`
  padding: 0;
  ${dinamicStyles}

  ${({ theme }) => theme.breakpoints.up("xl")} {
    display: flex;
    flex-wrap: wrap;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    gap: 27px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    gap: 36px;
  }
`

export default ListTwoStack
